import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";

export const styles = (theme: Theme) =>
	({
		marketChip: {
			height: 32,
			borderRadius: 16,
			backgroundColor: alpha(theme.palette.primary.main, 0.12),
			padding: theme.spacing(1, 2),
			gap: theme.spacing(1.25),
			margin: 4,
			display: "flex",
			alignItems: "center",
			"& .MuiChip-label": {
				fontSize: 14,
				lineHeight: "20px",
				fontFamily: theme.typography.fontFamily,
				fontWeight: 400,
				color: theme.palette.primary.dark,
				padding: 0,
			},
			"& .MuiChip-deleteIcon": {
				margin: 0,
				width: 16,
				height: 16,
				color: theme.palette.primary.dark,
			},
		},
	} satisfies Record<string, CSSObject>);
